/**
 * Mutation Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_PORTFOLIOS = (state) => {
    state.pending = true
}

/**
 * Set the portfolio list data
 *
 * @param  {Object} state
 * @param  {Object} portfolios
 * @return {Void}
 */
const PORTFOLIOS_GET_SUCCESS = (state, portfolios) => {
    state.data = portfolios.data
    state.meta = portfolios.meta
    state.pending = false
    state.loaded = true
}

/**
 * Handle a failed portfolio list request
 *
 * @param  {Object} state
 * @return {Void}
 */
const PORTFOLIOS_GET_FAILED = (state, error) => {
    state.pending = false
    state.loaded = false
}

/**
 * Reset the portfolio state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_PORTFOLIOS = (state) => {
    state.data = []
    state.meta = {}
    state.pending = false
    state.loaded = false
}

/**
 * Set the pending state for portfolio project list
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_PROJECT_LIST = (state) => {
    state.projects.pending = true
}

/**
 * Set the portfolio project list
 *
 * @param  {Object} state
 * @param  {Object} projects
 * @return {Void}
 */
const SET_PORTFOLIO_PROJECTS = (state, projects) => {
    state.projects.data = projects.data
    state.projects.meta = projects.meta
    state.projects.pending = false
}

/**
 * Handle the failed project list request
 *
 * @param  {Object} state
 * @param  {Object} projects
 * @return {Void}
 */
const SET_PORTFOLIO_PROJECTS_FAILED = (state, projects) => {
    state.projects.data = []
    state.projects.meta = {}
    state.projects.pending = false
}

/**
 * Reset the portfolio project list context
 *
 * @param  {Object} state
 * @param  {Object} projects
 * @return {Void}
 */
const RESET_PORTFOLIO_PROJECTS = (state, projects) => {
    state.projects.data = []
    state.projects.meta = {}
    state.projects.pending = false
}

/**
 * Add a project to the portfolio form
 *
 * @param  {Object} state
 * @param  {Integer} id
 * @return {Void}
 */
const ADD_PROJECT_TO_FORM = (state, id) => {
    state.form.selectedProjects.push(id)
}

/**
 * Remove a project from the portfolio form
 *
 * @param  {Object} state
 * @param  {Integer} id
 * @param  {Integer} index
 * @return {Void}
 */
const REMOVE_PROJECT_FROM_FORM = (state, index) => {
    state.form.selectedProjects.splice(index, 1)
}

/**
 * Handle a successful portfolio creation
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const PORTFOLIO_CREATED_SUCCESS = (state, payload) => {
    state.form.pending = false
    state.form.created = true
}

/**
 * Handle a failed portfolio creation
 *
 * @param  {Object} state
 * @param  {Object} error
 * @return {Void}
 */
const PORTFOLIO_CREATED_FAILURE = (state, error) => {
    state.form.errors = error
    state.form.pending = false
}

/**
 * Update the project form name state
 *
 * @param  {Object} state
 * @param  {String} payload
 * @return {Void}
 */
const UPDATE_PORTFOLIO_NAME = (state, payload) => {
    state.form.portfolioName = payload
    if (state.form.errors.name) {
        Vue.delete(state.form.errors, 'name')
    }
}

/**
 * Set the form pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
const PREPARE_PORTFOLIO_SUBMISSION = (state) => {
    state.form.pending = true
}

/**
 * Reset the form state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_PORTFOLIO_FORM = (state) => {
    state.form.pending = false
    state.form.created = false
    state.form.portfolioName = ''
    state.form.selectedProjects = []
    state.form.errors = {}
}

/**
 * Set the pending state when a portfolio is being accessed
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_EDIT_PORTFOLIO = (state) => {
    state.form.pending = true
}

/**
 * Handle successful portfolio retrieval
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const GET_EDIT_PORTFOLIO_SUCCESS = (state, payload) => {
    state.form.portfolioName = payload.name
    state.form.selectedProjects = payload.projects
    state.form.pending = false
}

/**
 * Handle failed portfolio retrieval
 *
 * @param  {Object} state
 * @param  {Object} err
 * @return {Void}
 */
const GET_EDIT_PORTFOLIO_FAILURE = (state, err) => {
    state.form.pending = false
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Handle updated portfolio state
 *
 * @param  {Object} state
 * @param  {Object} res
 * @return {Void}
 */
const PORTFOLIO_UPDATED_SUCCESS = (state, res) => {
    state.form.pending = false
    state.form.created = true
}

const PORTFOLIO_UPDATED_FAILURE = (state, err) => {
    console.log(err)
}

export default {
    RESET_STATE,
    GET_PORTFOLIOS,
    PORTFOLIOS_GET_SUCCESS,
    PORTFOLIOS_GET_FAILED,
    RESET_PORTFOLIOS,
    SET_PORTFOLIO_PROJECTS,
    SET_PORTFOLIO_PROJECTS_FAILED,
    RESET_PORTFOLIO_PROJECTS,
    GET_PROJECT_LIST,
    ADD_PROJECT_TO_FORM,
    REMOVE_PROJECT_FROM_FORM,
    PORTFOLIO_CREATED_SUCCESS,
    PORTFOLIO_CREATED_FAILURE,
    PREPARE_PORTFOLIO_SUBMISSION,
    UPDATE_PORTFOLIO_NAME,
    RESET_PORTFOLIO_FORM,
    GET_EDIT_PORTFOLIO,
    GET_EDIT_PORTFOLIO_SUCCESS,
    GET_EDIT_PORTFOLIO_FAILURE,
    PORTFOLIO_UPDATED_SUCCESS,
    PORTFOLIO_UPDATED_FAILURE
}



// WEBPACK FOOTER //
// ./src/state/modules/portfolios/mutations.js